import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'
import { ArrowRight } from '@/components/Icons'
import { AccentBar } from '@/components/AccentBar'
import { useEqualizeHeights } from '@/hooks/useEqualizeHeights'

export const gridBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current
  const theme = umbraco.Theme || 'light'
  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'
  const ContentAlignment = umbraco.ContentAlignment || 'center'

  // Use the custom hook for height equalization Ref :https://journey-digital.atlassian.net/browse/UMW-307
  const containerRef = useEqualizeHeights('.heading-match-height', [umbraco.Blocks])

  return (
    <div
      data-theme={theme} id={umbraco.AnchorTarget || undefined} className='_block-section _gridBlock-section relative isolate py-16 xl:py-16 text-[--theme-text]'
      style={{ backgroundColor }}
    >
      <AccentBar className={`${ContentAlignment !== 'left' ? 'h-[360px]' : 'h-[116px]'}`} umbraco={umbraco} />
      <div className={`${ContentAlignment !== 'left' ? 'mx-auto' : ''} mx-auto max-w-7xl`}>
        {(umbraco.Title || umbraco.SubTitle || umbraco.Summary) && (
          <div className={`${ContentAlignment !== 'left' ? 'mx-auto text-center max-w-7xl' : ''} px-4 pb-16 sm:px-6 lg:px-8`}>
            {
            umbraco.Title &&
              <h2 className='text-3xl font-extrabold sm:text-5xl mb-4 tracking-tight text-[--theme-highlight]'>{umbraco.Title}</h2>
          }
            {
            umbraco.SubTitle &&
              <h3 className='text-2xl font-extrabold sm:text-3xl tracking-tight text-[--theme-text-alt-3]'>{umbraco.SubTitle}</h3>
          }
            {
            umbraco.Summary &&
              <div className={`${ContentAlignment !== 'left' ? 'max-w-5xl mx-auto' : ''} text-pretty text-base font-semibold text-[--theme-text-alt-3] pt-4`} dangerouslySetInnerHTML={{ __html: umbraco.Summary }} />
          }
          </div>
        )}

        {
          umbraco.Blocks &&
            <div ref={containerRef} className='px-4 sm:px-6 lg:px-8 isolate gap-y-12 justify-center flex flex-wrap'>
              {umbraco.Blocks.map((block, index) => {
                const Tag = block.Button ? 'a' : 'div'
                const tagProps = block.Button
                  ? {
                      href: block.Button.Url,
                      target: block.Button.Target,
                      'aria-describedby': `grid-block-template ${index}`
                    }
                  : {}
                return (
                  <Tag key={index} className='-mt-10 w-full md:w-1/2 lg:w-1/3' {...tagProps}>
                    <div className={`relative px-3 w-full flex h-full flex-col max-w-[384px] mx-auto text-center space-y-3 pt-10 pb-7 ${block.Button ? 'group' : ''}`}>
                      {block.Media && block.Media.Image && (
                        <div className='mx-auto size-[120px] relative'>
                          {/* TODO: Image to go here with crop of 240 x 240 */}
                          <img src={block.Media.Image.Url} alt={block.Media.Image.AltText} className='w-full h-full object-cover' />
                        </div>
                      )}
                      <h4 id={`grid-block-template ${index}`} className='heading-match-height text-2xl font-extrabold pt-2 text-primary-950'>
                        {block.Title}
                      </h4>
                      <div
                        className='_simple-rte text-base font-semibold text-pretty text-[--theme-text-dark-muted]'
                        dangerouslySetInnerHTML={{ __html: block.Summary }}
                      />
                      <div className='flex flex-col justify-end grow'>
                        {
                        block.Button &&
                          <div className='pt-3'>
                            <Button
                              noInteraction
                              variant='primary'
                              size='sm'
                            >
                              {block.Button.Name}
                            </Button>
                          </div>
                      }
                      </div>
                      {block.Button && (
                        <div className='inset-0 -z-10 absolute bg-primary-50 scale-75 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all ease-in-out duration-300' />
                      )}
                    </div>
                  </Tag>
                )
              })}
            </div>
        }

        {
          umbraco.FooterCallout &&
            <div className='mx-auto pt-16 max-w-2xl text-center _simple-rte font-semibold' dangerouslySetInnerHTML={{ __html: umbraco.FooterCallout }} />
        }
        {
          umbraco.Button &&
            <div className='px-4 pt-10 sm:px-6 lg:px-8 isolate gap-y-16 justify-center flex flex-wrap'>
              <Button
                href={umbraco.Button.Url}
                target={umbraco.Button.Target}
                variant='primary-alt'
                size='lg'
              >
                <span className='block relative pr-7'>{umbraco.Button.Name} <ArrowRight className='absolute -right-0.5 top-1/2 -mt-[11px]' /></span>
              </Button>
            </div>
        }
      </div>
    </div>
  )
}

reactMount('gridBlock', gridBlock)
